/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "e.g. Legal Advisor, Customer Support Agent" |
*
* @param {Personas_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_name_placeholder = /** @type {((inputs?: Personas_Name_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Name_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("z.B. Rechtsberater, Kundensupport-Agent")
	return /** @type {LocalizedString} */ ("e.g. Legal Advisor, Customer Support Agent")
});